/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'weight': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 28',
    data: '<path pid="0" d="M3.4 20.2c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.7-1.7-1.7V6.8c0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7V1.7C3.4.8 4.2 0 5.1 0 6 0 6.8.8 6.8 1.7v10.1h20.4V1.7c0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7v5.1c0-.9.8-1.7 1.7-1.7.9 0 1.7.8 1.7 1.7v13.5c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v5.1c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7V15.2H6.8v10.1c0 .9-.8 1.7-1.7 1.7-.9 0-1.7-.8-1.7-1.7v-5.1z"/>'
  }
})
